import Script from 'next/script'
import React from 'react'

type ScriptDataProps = {
	data: string
}

export const ScriptData = React.memo(function ScriptData(props: ScriptDataProps) {
	return (
		<Script id="app-ld-json" type="application/ld+json">
			{props.data}
		</Script>
	)
})
